export default __webpack_public_path__ + "media/images/mcgill-background-ea6facd737553e3d04aec540a6f19441.jpg";